import { render, staticRenderFns } from "./imagesZoom.vue?vue&type=template&id=0ccd90f2&scoped=true&"
import script from "./imagesZoom.vue?vue&type=script&lang=js&"
export * from "./imagesZoom.vue?vue&type=script&lang=js&"
import style0 from "./imagesZoom.vue?vue&type=style&index=0&id=0ccd90f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccd90f2",
  null
  
)

/* custom blocks */
import block0 from "./imagesZoom.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports